import { render, staticRenderFns } from "./order-date-range.vue?vue&type=template&id=c3a97496&scoped=true&"
import script from "./order-date-range.component.ts?vue&type=script&lang=ts&"
export * from "./order-date-range.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-date-range.scss?vue&type=style&index=0&id=c3a97496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a97496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a97496')) {
      api.createRecord('c3a97496', component.options)
    } else {
      api.reload('c3a97496', component.options)
    }
    module.hot.accept("./order-date-range.vue?vue&type=template&id=c3a97496&scoped=true&", function () {
      api.rerender('c3a97496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/components/order-date-range/order-date-range.vue"
export default component.exports